import { render, staticRenderFns } from "./PreviewIcon.vue?vue&type=template&id=23bc4d65"
import script from "./PreviewIcon.vue?vue&type=script&lang=ts"
export * from "./PreviewIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports